import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import EditBillForm from '../Forms/EditBillForm';

const EditBillModal = ({ show, onHide, bill, onSuccess, onDelete, simplified = true }) => {
  const handleSuccess = (updatedBill) => {
    onSuccess(updatedBill);
    onHide();
  };

  const handleDelete = (applyToAll) => {
    // Call the parent's onDelete function with the bill ID and series ID if applicable
    onDelete(bill.id, applyToAll ? bill.bill_series_id : null);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Bill</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EditBillForm 
          bill={bill}
          onSuccess={handleSuccess}
          onCancel={onHide}
          onDelete={handleDelete}
          simplified={simplified}
        />
      </Modal.Body>
    </Modal>
  );
};

export default EditBillModal; 